
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"36"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 2046"}},[_c('g',{attrs:{"data-name":"그룹 2045","transform":"translate(13.909 11)","fill":"#3c3c3c"}},[_c('circle',{attrs:{"data-name":"타원 252","cx":"1.5","cy":"1.5","r":"1.5"}}),_c('circle',{attrs:{"data-name":"타원 253","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(0 6)"}}),_c('circle',{attrs:{"data-name":"타원 254","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(0 12)"}})]),_c('path',{attrs:{"data-name":"사각형 2744","fill":"none","d":"M0 0h30v36H0z"}})])])
          )
        }
      }
    